export default "__VITE_ASSET__CXkolUGM__"